import angular from 'angular';

export default class UserEditCampaigns {
  constructor($scope, OfferCampaignService, UserService, PaginationService) {
    $scope.tabs = [
      {
        title: 'All',
        status: null,
        campaigns: [],
        loading: false,
        page: 1
      },
      {
        title: 'Pending',
        status: 2,
        campaigns: [],
        loading: false,
        page: 1
      },
      {
        title: 'Sent',
        status: 1,
        campaigns: [],
        loading: false,
        page: 1
      }
    ];
    
    $scope.set_selected_tab = function(index) {
      $scope.selected_tab = index;
    };
    
    $scope.load_data = function(tab) {
      $scope.loading = true;
      tab.loading = true;
      var filters = $scope.common_filters();
      filters.page = tab.page;
      filters.status = tab.status;
      filters.date_from = $scope.filter.date_from;
      filters.date_to = $scope.filter.date_to;
      OfferCampaignService.get(filters).success(function(data) {
        tab.campaigns = data.campaigns;
        tab.pagination = PaginationService.get_pagination(data.pagination);
        $scope.loading = false;
        tab.loading = false;
      });
    };
    
    $scope.load_all_data = function() {
      angular.forEach($scope.tabs, function(tab) {
        $scope.load_data(tab);
      });
    };
    
    $scope.common_filters = function() {
      if (window.user_type == 'Seller')
        return {
          supplier_id: window.user_id
        };
      else
        return {
          buyer_id: window.user_id
        };  
    };


    $scope.init = function() {
      $scope.filter = {};
      $scope.stocklists = {};
      $scope.selected_tab = 0;
      $scope.filter.date_from = new Date(new Date().getFullYear(), 0, 1);
      $scope.load_all_data();
      UserService.get_stocklists(window.user_id).then(function(data) {
        angular.forEach(data.stocklists, function(entry) {
          $scope.stocklists[entry.campaign_id] = entry;
        });
      });
    };

    $scope.init();

  }
}

UserEditCampaigns.$inject = ['$scope', 'OfferCampaignService', 'UserService', 'PaginationService'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/user-edit-campaigns.ctrl.js